import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0514',
    ecrans: ['00-2'],
    params: ['?demcleint']
});
